import * as React from 'react';
import { QuestionMark } from './ui/QuestionMark';
import { SpecialDataType } from './Import';
import { IHasTranslator } from '../ApplicationState';

export type ColumnDefinition<TEntity> = Readonly<{
    columnTitle: string;
    language?: string;
    formatDescription: string;
    maxLength?: number;
    isSpecialDataType?: SpecialDataType;
    requiredYesOrNo: string;
    propertyName: keyof TEntity;
}>;

interface ImportHelpProps<TEntity> extends IHasTranslator {
    importObjectName: string;
    importObjectNamePlural: string;
    columnDefinitions: ColumnDefinition<TEntity>[];
}

class ImportHelp<TEntity> extends React.Component<ImportHelpProps<TEntity>> {
    render() {
        const { t, columnDefinitions } = this.props;
        const hasLanguageColumn = columnDefinitions.some(c => c.language !== undefined);

        return <QuestionMark>
                   <div className="popup-help">
                       <h2>{t['Workflow importing ']}{this.props.importObjectNamePlural}</h2>
                       <ul>
                           <li>{t['Choose an Excel document with']} {this.props.importObjectNamePlural} {t['to upload']}</li>
                           <li>{t['Click \'Parse data\'']}</li>
                           <li>{t['An overview appears for reviewing the data']}</li>
                           <li>{t['Click \'Save\' to actually import the data']}</li>
                       </ul>
                       <p>{t['Requirements for the Excel document:']}</p>
                       {<table className="import-column-definition">
                    <tbody>
                        <tr>
                            <th>{t['Column']}</th>
                            {hasLanguageColumn ? <th>{t['Language']}</th> : null}
                            <th>{t['Format']}</th>
                            <th>{t['Required']}</th>
                        </tr>
                        {columnDefinitions.map(col =>
                            <tr key={String(col.propertyName) + col.language}>
                                <td>{col.columnTitle}</td>
                                {hasLanguageColumn ? <td>{col.language}</td> : null}
                                <td>{col.formatDescription}</td>
                                <td>{col.requiredYesOrNo}</td>
                            </tr>)}
                    </tbody>
                </table>}
                       <ul>
                           <li>{t['The Excel document contains one ']}{this.props.importObjectName} {t['per row']}</li>
                           <li>{t['The Excel document can\'t have a headerrow with e.g. column names']}</li>
                           <li>{t['The columns are in the above defined order']}</li>
                       </ul>
                   </div>
               </QuestionMark>
    }
}

export { ImportHelp };
